import { Controller } from "stimulus";

// https://bugzilla.mozilla.org/show_bug.cgi?id=1459147
export default class extends Controller {
  connect() {
    this.element.contentWindow.location.href = this.element.src
  }
}